import React from "react";
import { Compass, CheckCircle2, LineChart } from "lucide-react";
import PhoneMockup from "./PhoneMockup";
import Reveal from "./Reveal";
import { expeditions } from "../mock";

const iconMap = { Compass, CheckCircle2, LineChart };

const Expeditions = () => {
  return (
    <section id="expeditions" className="relative bg-velis-dark py-16 lg:py-20 overflow-hidden">
      {/* subtle glow */}
      <div
        className="absolute top-1/2 -left-40 -translate-y-1/2 w-[600px] h-[600px] opacity-40 pointer-events-none"
        style={{ backgroundImage: "url(/images/gold-glow.jpg)", backgroundSize: "cover", mixBlendMode: "screen" }}
      />
      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal className="flex justify-center lg:order-2">
          <PhoneMockup src={expeditions.image} alt="Expédition en cours VÉLIS" width={220} />
        </Reveal>

        <div className="lg:order-1">
          <Reveal>
            <h2 className="font-display font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
              {expeditions.title}
            </h2>
            <p className="mt-5 text-white/70 text-lg leading-relaxed max-w-lg">{expeditions.subtitle}</p>
          </Reveal>

          <div className="mt-8 space-y-3">
            {expeditions.items.map((item, i) => {
              const Icon = iconMap[item.icon];
              return (
                <Reveal key={item.title} delay={i * 120}>
                  <div className="flex items-center gap-4 rounded-2xl border border-white/8 bg-velis-card p-4 hover:border-[var(--velis-orange)]/40 transition-colors">
                    <div className="shrink-0 w-11 h-11 rounded-xl bg-[var(--velis-orange)]/15 flex items-center justify-center">
                      <Icon className="text-velis-orange" size={20} />
                    </div>
                    <span className="font-display font-semibold text-white text-lg flex-1">{item.title}</span>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Expeditions;
